module.exports = __webpack_public_path__ + "img/DSC_2751-xl.60fc589a.png";